import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export const useSiteContent = () => {
  const [content, setContent] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/content")
      .then((res) => {
        cache = res.data;
        setContent(res.data);
      })
      .catch(() => {});
  }, []);
  return content;
};

export const invalidateSiteContent = () => {
  cache = null;
};
